import { render, staticRenderFns } from "./customform.vue?vue&type=template&id=1c3dc07e&scoped=true&"
import script from "./customform.vue?vue&type=script&lang=js&"
export * from "./customform.vue?vue&type=script&lang=js&"
import style0 from "./customform.vue?vue&type=style&index=0&id=1c3dc07e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3dc07e",
  null
  
)

export default component.exports